/* @flow */
import * as React from 'react';

const ArrowBigVioletLeft = props => (
  <svg width={24} height={16} viewBox="0 0 24 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      fillRule="evenodd"
      d="M22.969,7 L3.889,7 L9.561,1.257 C9.864,0.983 9.563,0.522 9.279,0.229 C9.131,0.077 8.932,0 8.732,0 C8.548,0 8.363,0.065 8.219,0.197 L0.234,7.47 C0.174,7.53 0.164,7.564 0.143,7.593 C0.101,7.656 0.074,7.682 0.06,7.713 C0.036,7.776 0.033,7.821 0.025,7.865 C0.017,7.907 0.001,7.947 0,7.99 C0.001,8.054 0.017,8.094 0.025,8.136 C0.034,8.181 0.036,8.225 0.053,8.267 C0.074,8.319 0.101,8.344 0.119,8.374 C0.164,8.438 0.174,8.471 0.2,8.498 C0.23,8.524 8.218,15.803 8.218,15.803 C8.519,16.077 8.993,16.064 9.278,15.771 C9.562,15.479 9.863,15.018 9.561,14.743 L3.889,9 L22.969,9 C23.383,9 24,8.402 24,8 C24,7.599 23.383,7 22.969,7 Z"
    />
  </svg>
);

export default ArrowBigVioletLeft;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-big-violet-left.js